import { useState } from 'react'
import { cn } from '@/lib/utils'
import { CoverPlaceholder } from './CoverPlaceholder'

interface Props {
  seed: number
  banner?: string | null
  alt: string
}

/**
 * Обложка карточки курса. Пока баннер грузится (они тяжёлые — до 2560px), под ним
 * лежит фирменная заглушка, а не серая плашка: в «Исследовать» половина карточек
 * иначе выглядела курсами без обложки. Загрузилась — картинка проявляется поверх;
 * не загрузилась — заглушка остаётся, как у курса без баннера.
 */
const CoverImage = ({ seed, banner, alt }: Props) => {
  const [state, setState] = useState<'loading' | 'loaded' | 'broken'>('loading')
  return (
    <>
      {state !== 'loaded' ? <CoverPlaceholder seed={seed} className="absolute inset-0" /> : null}
      {banner && state !== 'broken' ? (
        <img
          src={banner}
          alt={alt}
          // Из кеша картинка бывает готова раньше, чем React повесил onLoad.
          ref={(img) => {
            if (img?.complete && img.naturalWidth > 0) setState('loaded')
          }}
          onLoad={() => setState('loaded')}
          onError={() => setState('broken')}
          className={cn(
            'relative block size-full object-cover transition-opacity duration-300',
            state === 'loaded' ? 'opacity-100' : 'opacity-0',
          )}
        />
      ) : null}
    </>
  )
}

/** Ключ — адрес баннера: «сломано»/«загружено» относятся к адресу, а не к карточке. */
export const CourseCoverImage = (props: Props) => <CoverImage key={props.banner ?? ''} {...props} />
